export default __webpack_public_path__ + "static/media/diners.dfc953d2.svg";